<p class="h5 text-left py-3 text-muted"><strong>Your Order Summary</strong></p>
<form [formGroup]="promoCodeForm">
  <div class="input-group mb-3 pt-3">
    <div class="input-group-prepend">
      <button class="btn btn-md btn-outline-primary m-0 px-3 py-2 z-depth-0 waves-effect"
              style="line-height: 1.15; text-transform: uppercase; font-size: 0.7rem"
              type="button"
              (click)="calculateCoupon()"
              id="button-addon1"
              data-testid="cart-page-apply-coupon"
              #promocodebutton>
        Apply Coupon
      </button>
    </div>
    <input type="text"
           mdbInput
           formControlName="promoCode"
           (keyup.enter)="promocodebutton.click()"
           class="form-control"
           data-testid="cart-page-enter-coupon"
           placeholder="Enter Coupon" />
  </div>
</form>

<app-checkout-summary [cartSummary]="cartSummary"></app-checkout-summary>

<button class="btn btn-success btn-lg btn-block"
        (click)="savePaymentAndCompletePurchase()"
        type="submit"
        style="background-color: #4caf50"
        data-testid="complete-purchase">
  <i class="fas fa-check"></i> {{ this.isLease ? "Apply" : "Complete Purchase" }}
</button>

<hr />
<form [formGroup]="checkoutForm">
  <!--Material textarea-->
  <div class="md-form md-outline">
    <textarea id="form75"
              class="md-textarea form-control"
              rows="3"
              id="specialinstructions"
              name="specialinstructions"
              formControlName="specialinstructions"
              data-testid="special-instructions-textarea"
              mdbInput></textarea>
    <label for="specialinstructions">Special Instructions</label>
  </div>

  <hr />
  <!-- Material unchecked -->
  <div class="form-check">
    <input type="checkbox"
           class="form-check-input"
           formControlName="subscribeToNewsletter"
           id="subscribeToNewsletter"
           data-testid="subscribe-newsletter-checkbox" 
           name="subscribeToNewsletter" />
    <label class="form-check-label" for="subscribeToNewsletter"><span class="font-small">Subscribe me to your newsletter for the latest deals.</span></label>
  </div>
</form>
<iframe name="ddc-iframe" height="10" width="10" style="display: none"></iframe>
<form id="ddc-form"
      target="ddc-iframe"
      method="POST"
      *ngIf="payerAuthSetupResponse"
      [action]="payerAuthSetupResponse.deviceDataCollectionURL"
      #ddcForm>
  <input type="hidden" name="JWT" [value]="payerAuthSetupResponse.accessToken" />
</form>
<div class="modal fade"
     tabindex="-1"
     aria-modal="true"
     role="dialog"
     mdbModal
     #stepUpModal="mdbModal"
     data-testid="step-up-modal"
     (closed)="onStepUpClosed()">
  <div class="modal-dialog modal-dialog-centered" style="width: fit-content">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" 
          class="close pull-right" 
          aria-label="Close" 
          (click)="service.checkingOutState = ProcessingState.Ready"
          data-testid="close-step-up-modal-button"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100">Purchase Authentication</h4>
      </div>
      <div class="modal-body p-0" *ngIf="service.checkingOutState === ProcessingState.ChallengeReceived">
        <iframe name="step-up-iframe"
                [height]="authorizationResponse.Challenge.windowDimensions.height"
                [width]="authorizationResponse.Challenge.windowDimensions.width"
                class="step-up-iframe"></iframe>
      </div>
    </div>
  </div>
</div>
<form *ngIf="service.checkingOutState === ProcessingState.ChallengeReceived"
      id="step-up-form"
      target="step-up-iframe"
      method="post"
      [action]="authorizationResponse.Challenge.StepUpUrl"
      #stepUpForm>
  <input type="hidden" name="JWT" [value]="authorizationResponse.Challenge.AccessToken" />
  <input type="hidden" name="MD" [value]="stepUpMerchantData" />
</form>
<form [action]="authResultUrl"
      #authResultForm
      method="POST"
      style="display: none"
      *ngIf="service.checkingOutState === ProcessingState.AuthorizationReceived">
  <input type="hidden" [value]="authorizationResponse.Transaction.OrderNumber" name="orderNumber" />
  <input type="hidden" [value]="authorizationResponse.Transaction.PaymentComments" name="messageTxt" />
  <input type="hidden" [value]="authorizationResponse.ReasonCode" name="reasonCode" />
</form>
